import React from 'react';
import AluminumFoilInsulation from "../images/products/AluminumFoilInsulation/products.json"
import PuffInsulation from "../images/products/PuffInsulation/products.json"
import InsulationSheets from "../images/products/InsulationSheets/products.json"
import PhenolicFoamInsulationPipe from "../images/products/PhenolicFoamInsulationPipe/products.json"
import PolyurethaneFoamSheet from "../images/products/PolyurethaneFoamSheet/products.json"
import PUFPipeSection from "../images/products/PUFPipeSection/products.json"
import FRPProducts from "../images/products/FRPProducts/products.json"
import ThermalInsulationSheet from "../images/products/ThermalInsulationSheet/products.json"

export default function Products() {
    return (
        <div className="container mt-4">

            <div className="row">
                <p className='roboto fs-5'>
                    Starking Insulation offers a full range of advanced thermal insulation products designed for maximum energy efficiency and performance.
                    Our solutions—ranging from foam, PUF, phenolic, and PU sheets to pipe sections and foil insulation—provide reliable temperature control in all environments.
                    Each product is engineered for durability, moisture resistance, and long-lasting thermal stability.
                    Ideal for industrial, commercial, refrigeration, HVAC, and construction applications.
                    We deliver dependable insulation solutions that enhance safety, reduce energy costs, and improve overall system performance.
                </p>
            </div>

            

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Puff Insulation</span></h3>
                <p class="fs-5">We are a leading Manufacturer of Door Frame Puff Insulation from Pune, India. Foam insulation offers excellent thermal resistance and sound absorption.
                    Used widely in residential, commercial, and industrial projects.
                    Its lightweight structure enhances installation speed and flexibility.
                    Helps reduce energy consumption by minimizing heat loss.
                    A reliable solution for consistent long-term insulation performance.</p>
                {PuffInsulation.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/PuffInsulation/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>FRP Products</span></h3>
                <p class="fs-5">Our range of products include Rectangular FRP Products. FRP Products deliver outstanding insulation for roofing, cold rooms, and panels.
                    Known for low thermal conductivity and high mechanical strength.
                    Lightweight and easy to handle for quick installation.
                    Highly resistant to moisture, fire, and environmental wear.
                    Ensures consistent performance in both hot and cold applications.</p>
                {FRPProducts.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/FRPProducts/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Polyurethane Foam Sheet</span></h3>
                <p class="fs-5">Leading Manufacturer of Off White Polyurethane Foam Sheet, Black Polyurethane Foam Sheet, Rigid Polyurethane Foam Sheet, Grey Polyurethane Foam Sheet and Coated Polyurethane Foam Sheet from Pune. PU foam sheets offer excellent insulation with high compressive strength.
                    Suitable for cold storage, roofing, panels, and industrial equipment.
                    Lightweight yet durable, ensuring long-term thermal performance.
                    Resistant to moisture, chemicals, and environmental impact.
                    Provides superior energy-saving benefits across applications.</p>
                {PolyurethaneFoamSheet.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/PolyurethaneFoamSheet/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Phenolic Foam</span></h3>
                <p class="fs-5">We are a leading Manufacturer of Phenolic Foam and PUF Round Pipe Section from Pune, India. Phenolic foam pipes provide superior fire resistance and low thermal conductivity.
                    Ideal for HVAC systems, chilled water lines, and industrial pipelines.
                    Lightweight and easy to install with high structural stability.
                    Minimizes energy loss and prevents surface condensation.
                    A reliable choice for high-performance insulation in critical applications.</p>
                {PhenolicFoamInsulationPipe.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/PhenolicFoamInsulationPipe/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>PUF Pipe Section</span></h3>
                <p class="fs-5">Our product range includes a wide range of PUF Pipe Section and Puff Pipe Section. PUF pipe sections provide strong thermal insulation for hot and cold pipelines.
                    Ideal for chemical plants, refineries, chilled water lines, and process industries.
                    Made with high-density PUF for excellent temperature stability.
                    Prevents heat loss and eliminates condensation on pipes.
                    Easy to install, long-lasting, and resistant to moisture and corrosion.</p>
                {PUFPipeSection.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/PUFPipeSection/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Thermal Insulation Sheet</span></h3>
                <p class="fs-5">Offering you a complete choice of products which include Glass Wool Thermal Insulation Sheet. Thermal insulation sheets provide efficient control of heat flow.
                    Used in buildings, industrial systems, HVAC, and machinery.
                    Reduces energy costs by minimizing heat gain and loss.
                    Durable, flexible, and suitable for a wide range of temperatures.
                    Ensures improved system efficiency and long-term reliability.</p>
                {ThermalInsulationSheet.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/ThermalInsulationSheet/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Aluminum Foil Insulation</span></h3>
                <p class="fs-5">Our product range includes a wide range of Aluminum Foil Insulation. Aluminum foil insulation provides superior heat reflection and vapor resistance.
                    Ideal for roofs, walls, ducts, and industrial insulation applications.
                    Lightweight, durable, and easy to install in any environment.
                    Reduces heat transfer, improving overall energy efficiency.
                    Perfect for maintaining controlled temperatures in buildings and factories.</p>
                {AluminumFoilInsulation.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/AluminumFoilInsulation/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row">
                <h3 className='product-title'><span className='roboto-title'>Insulation Sheets</span></h3>
                <p class="fs-5">Our range of products include Polyurethane Insulation Sheets. High-performance insulation sheets suitable for various temperature conditions.
                    Available in multiple thicknesses for customized applications.
                    Used in construction, HVAC, cold storage, and industrial projects.
                    Provides excellent thermal and acoustic control.
                    Durable, moisture-resistant, and designed for long-term efficiency.</p>
                {InsulationSheets.map((item) => (
                    <div className="col-12 col-md-6 col-lg-3 p-3" key={item.id}>
                        <div className="card h-100">
                            <div className='imagediv'>
                            <img className="card-img-top" src={require(`../images/products/InsulationSheets/${item.image}`)} alt="Card image" />
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">{item.name}</h4>
                                {/* <p className="card-text">{item.details}</p> */}
                                {/* <a href="#" className="btn btn-primary">{item.profile}</a> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
}
